import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Chart, CategoryScale, LinearScale, BarController, BarElement } from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarController, BarElement);

const WeatherGraph = ({ username, onClose }) => {
  const [events, setEvents] = useState([]);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${API_URL}/username/${username}`);
        setEvents(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchEvents();
  }, [username]);

  useEffect(() => {
    if (events.length > 0) {
      createChart();
    }
  }, [events]);

  const createChart = () => {
    const ctx = document.getElementById('chart').getContext('2d');

    const eventCounts = {};
    events.forEach((event) => {
      const { events } = event;
      if (eventCounts[events]) {
        eventCounts[events]++;
      } else {
        eventCounts[events] = 1;
      }
    });

    const labels = Object.keys(eventCounts);
    const counts = Object.values(eventCounts);

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: 'Event Counts',
            data: counts,
            backgroundColor: 'rgba(75, 192, 192, 0.8)',
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            type: 'linear',
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      },
    });
  };

  return (
    <div className="popup">
      <div className="popup-content">
        <h1>Συμβάντα</h1>
        <canvas id="chart" width={400} height={200}></canvas>
        <button className="close-button" onClick={onClose}>
          Κλείσιμο
        </button>
      </div>
    </div>
  );
};

export default WeatherGraph;
